<template>
    <el-button @click="exportData">
        Export
    </el-button>
    <el-button @click="showImportModal = true">
        Import
    </el-button>
    <el-dialog
        v-model="showImportModal"
        title="Import PMO Categories"
        width="30%"
        @close="showImportModal = false"
    >
        <el-form
            ref="importForm"
            :model="importForm"
        >
            <div>
                <p>Warning: Importing will <strong>overwrite all existing data</strong>.</p>
                <p>Make sure you have a backup of your data before importing.</p>
            </div>
            <el-form-item label="File">
                <el-upload
                    ref="upload"
                    :auto-upload="false"
                    :file-list="fileList"
                    :limit="1"
                    :show-file-list="true"
                    accept=".json"
                    :on-change="onChangeHandler"
                >
                    <el-button
                        size="small"
                        type="primary"
                    >
                        Select File
                    </el-button>
                    <template #tip>
                        <div class="el-upload__tip">
                            Only .json files are allowed
                        </div>
                    </template>
                </el-upload>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="showImportModal = false">Cancel</el-button>
                <el-button
                    type="primary"
                    @click="importData"
                >Import</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import pmoApi from '../pmoApi'

const emit = defineEmits()

const showImportModal = ref(false)
const importForm = ref({})
const upload = ref(null)
const fileList = ref([])

const fileData = ref(null)

const exportData = () => {
    pmoApi.export().then((response) => {
        const href = URL.createObjectURL(response.data)
        let filename = response.headers['x-suggested-filename']
        filename = filename.replace(/"/g, '')

        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        URL.revokeObjectURL(href)
    })
}

const importData = () => {
    if(!fileData.value) {
        return
    }

    const data = new FormData()
    data.append('file', fileData.value)

    pmoApi.import(data).then((response) => {
        showImportModal.value = false
        fileList.value = []
        fileData.value = null
        ElMessage({
            message: 'Imported successfully',
            type: 'success'
        })

        emit('refresh')
    })
}

const onChangeHandler = (file) => {
    fileData.value = file.raw
}



</script>
